export default __webpack_public_path__ + "static/media/resume.f5b9d5e1.jpg";